import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  ADD_ADMIN_WALLET_BALANCE,
  FETCH_ADMIN_BALANCE,
  FETCH_ADMIN_WALLET,
  FETCH_ALL_ERR_ERC20,
  FETCH_ALL_ERR_TOMO_ERC20,
  FIX_ERR_ERC20,
  FIX_ERR_TOMO_ERC20,
  MIGRATE_BTC,
  MIGRATE_ERC20,
  MIGRATE_ETH, SET_ADMIN_TRANSFER,
} from '../actions/admin_wallet/action_types';
import actions from '../actions/admin_wallet';
import rf from '../../requests/RequestFactory';
import { FETCH_OWN_BALANCE } from '../actions/admin/action_types';
// saga effect

function* addAdminWalletBalance(action) {
  try {
    yield call((params) => rf.getRequest('AdminWalletRequest').addAdminWallet(params), action.params);
    yield put(actions.addAdminWalletBalanceActionSucceed());
  } catch (err) {
    console.log('err', err);
    yield put(actions.addAdminWalletBalanceActionFailed(err));
  }
}

function* fetchAdminWallet(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').fetchAdminWallet(params), action.params);
    yield put(actions.fetchAdminWalletActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchAdminWalletActionFailed(err));
  }
}

function* fetchAllERC20(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').fetchAllErrERC20(params), action.params);
    yield put(actions.fetchAllErrERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchAllErrERC20ActionFailed(err));
  }
}

function* fetchAllTomoERC20(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').fetchAllErrTomoERC20(params), action.params);
    yield put(actions.fetchAllErrTomoERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchAllErrTomoERC20ActionFailed(err));
  }
}

function* fetchAdminBalance(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').fetchAdminBalances(params), action.params);
    yield put(actions.fetchAdminBalancesActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchAdminBalancesActionFailed(err));
  }
}

function* migrateBTC(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').migrateBTC(params), action.params);
    yield put(actions.migrateBTCActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    console.log('err', err);
    yield action.callback();
    yield put(actions.migrateBTCActionFailed(err));
  }
}

function* migrateETH(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').migrateETH(params), action.params);
    yield put(actions.migrateETHActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    console.log('err', err);
    yield action.callback();
    yield put(actions.migrateETHActionFailed(err));
  }
}

function* migrateERC20(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').migrateERC20(params), action.params);
    yield put(actions.migrateERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    console.log('err', err);
    yield action.callback();
    yield put(actions.migrateERC20ActionFailed(err));
  }
}

function* fixErrERC20(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').fixErrERC20(params), action.params);
    yield put(actions.fixErrERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fixErrERC20ActionFailed(err));
  }
}

function* fixErrTomoERC20(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').fixErrTomoERC20(params), action.params);
    yield put(actions.fixErrTomoERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fixErrTomoERC20ActionFailed(err));
  }
}

function* setAdminTransfer(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminWalletRequest').setAdminTransfer(params), action.params);
    yield put(actions.setAdminTransferSuccess(data));
    yield put(actions.fetchAdminWalletAction());
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.setAdminTransferFailed(err));
  }
}

function* watchAdminWalletBalance() {
  yield takeLatest(ADD_ADMIN_WALLET_BALANCE, addAdminWalletBalance);
  yield takeLatest(FETCH_ADMIN_WALLET, fetchAdminWallet);
  yield takeLatest(FETCH_ADMIN_BALANCE, fetchAdminBalance);
  yield takeLatest(FETCH_ALL_ERR_ERC20, fetchAllERC20);
  yield takeLatest(FETCH_ALL_ERR_TOMO_ERC20, fetchAllTomoERC20);
  yield takeLatest(MIGRATE_BTC, migrateBTC);
  yield takeLatest(MIGRATE_ETH, migrateETH);
  yield takeLatest(MIGRATE_ERC20, migrateERC20);
  yield takeLatest(FIX_ERR_ERC20, fixErrERC20);
  yield takeLatest(FIX_ERR_TOMO_ERC20, fixErrTomoERC20);
  yield takeLatest(SET_ADMIN_TRANSFER, setAdminTransfer);
}

export default function* rootSaga() {
  yield all([fork(watchAdminWalletBalance)]);
}
